import React, {useState} from 'react';
import {Grid, Card, CardActionArea, CardContent, Divider, IconButton, Button } from '@mui/material/';
import {useStyles} from './styles';
import {Visibility} from '@mui/icons-material';
import Base64Pdf from '../base64pdf';
import EditIcon from '@mui/icons-material/Edit';

function Card64Pdf(props) {
    const classes = useStyles(props),
    [verPDF, setVerPDF] = useState(false),
    [datosPDF, setDatosPDF] = useState({pdf:'', title:'',});

    const convertirBase64AUrl = (pdf) => {
        if (!pdf || typeof pdf !== 'string') return '';
        if (pdf.startsWith('data:') || pdf.startsWith('blob:')) return pdf;

        const base64 = pdf.includes('base64,') ? pdf.split('base64,')[1] : pdf;

        try {
            const binary = window.atob(base64);
            const bytes = new Uint8Array(binary.length);
            for (let index = 0; index < binary.length; index += 1) {
                bytes[index] = binary.charCodeAt(index);
            }
            const blob = new Blob([bytes], { type: 'application/pdf' });
            return URL.createObjectURL(blob);
        } catch (error) {
            return `data:application/pdf;base64,${pdf}`;
        }
    };

    const VerPDF = async (datosPDF)=>{

        if(props.getDocumentOfPoliticalOrganization) {
            const data = await props.getDocumentOfPoliticalOrganization(datosPDF.documentName);
            if(data) {
                setDatosPDF({pdf: data?.pdf, title: props?.label})
                 setVerPDF(true)
            }
        } else {
            if(datosPDF?.pdf) {
                setDatosPDF({pdf: datosPDF?.pdf, title: props?.label})
                setVerPDF(true)
            }
        }
    }

    const CerrarVerPDF =()=>{
        setVerPDF(false)
    }

    return (
        <div>
            <Grid container className={classes.rootGrid} justifyContent="center" >
                <Grid item className={classes.itemGrid}>
                    <Card className={classes.rootCard} >
                        <CardActionArea>
                            <div className={props.contentMediaTable ? classes.contentMediaTable : classes.contentMedia}>
                            {props.pdf ? (
                                <iframe src={convertirBase64AUrl(props.pdf)} width={props.width} height={props.height} allowFullScreen loading={"lazy"}/>
                            ) : <h3>{props.label} </h3>}
                            </div>
                            {props.showTitle && (
                                <CardContent  className={classes.cardContent}>
                                    <Grid item xs={12}>
                                        <div className={classes.centerTitle}><Divider /> <strong>{props.label}</strong> <Divider /></div>
                                    </Grid >
                                </CardContent>
                            )}
                        </CardActionArea>
                        {props.pdf ? (
                        <IconButton size={"large"} className={classes.iconVisibility} onClick={()=>VerPDF({pdf: props.pdf, documentName: props.documentName})}><Visibility  style={{ fontSize: props.contentMediaTable ? 25 : 30 }} /></IconButton>
                        ) : null }
                    </Card>
                    {props.showTitle2 && (
                    <CardContent  className={classes.cardContent}>
                        <Grid item xs={12}>
                            <div className={classes.centerTitle2}><Divider /> <strong >{props.title}</strong> <Divider /></div>
                        </Grid >
                        {props.showButtonEditDocument && (
                            <Button variant="contained" color="primary" className={classes.button} onClick={() => props.handleClickUpdateDocument(props)}>
                                <EditIcon  />
                                {props.firstTitle} {props.title}
                            </Button>
                        )}
                        {props.observacion && (
                         <div className={classes.observacion}><Divider /> <strong>{props.observacion}</strong> <Divider /></div>
                        )}
                    </CardContent>
                    )}
                </Grid>
                <Base64Pdf pdf={datosPDF.pdf} title={datosPDF.title} open={verPDF} handleClose={CerrarVerPDF}  showDownloadButton={props.showDownloadButton} src={props.src} />
            </Grid>
        </div>
    );
}

Card64Pdf.defaultProps = {
    showInMovil : false,
    showTitle2: false,
    showButtonEditDocument: false,
    firstTitle: "Actualizar ",
    width:"100%",
    height:"100%",
    contentMediaTable: false,
    handleClickUpdateDocument: () => {},
}


export default Card64Pdf;